import { useQuery } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { axiosClient } from "api/http/config";
import {
  productionDeviationIdsSchema,
  ProductionDeviationResponse,
  productionDeviationSchema,
} from "features/CenterContent/RoleContent/ProductionDeviation/types/responseSchema";
import { useCountryCodeForDropsRole } from "shared/hooks/useCountryCodeForDropsRole";

export const productionDeviationQueryKey = (countryCode: string) => [
  "productionDeviation",
  countryCode,
];

export const allProductionDeviationsQueryKey = ["productionDeviation", "all"];

export const useProductionDeviations = () => {
  const countryCode = useCountryCodeForDropsRole();

  const productionDeviations = useQuery({
    queryKey: productionDeviationQueryKey(countryCode),
    staleTime: 0,
    queryFn: ({ signal }) =>
      axiosClient
        .get<ProductionDeviationResponse[]>(
          `${getBackendUrl()}/production-deviation/active-deviations`,
          {
            signal,
          },
        )
        .then((res) =>
          res.data.map((it) => productionDeviationSchema.parse(it)),
        ),
  });

  return productionDeviations;
};

export const useActiveProductionDeviationIds = () => {
  const productionDeviations = useQuery({
    queryKey: allProductionDeviationsQueryKey,
    staleTime: 0,
    queryFn: ({ signal }) =>
      axiosClient
        .get(`${getBackendUrl()}/production-deviation/active-ids`, {
          signal,
        })
        .then((res) => productionDeviationIdsSchema.parse(res.data)),
  });

  return productionDeviations;
};
